module.exports = __webpack_public_path__ + "media/images/sprite/ico-linkedin-3a0b6801ca75b3a659208fc2879b6381.png";